





























import { Component, Prop, Watch, Emit, Mixins } from "vue-property-decorator";
import { Point, Size, Rectangle, Vector, DraggingOffsets } from "../../../../../../base/domain/drawing";
import { AsyncRequestPool, AsyncUtility } from "../../../../../../base/utilities";
import { RectangleLayoutableMixin } from "../../../../../../base/components/system/mixins";
import { IFormatObjectEditable } from "../../../../../domain/editableFormat";
import { QuestionnaireGuidTree } from "../../../../../domain/questionnaire";
import { instanceOfIRectangleCoordinateEditable } from "../../../../../domain/editableFormat/properties";
import { default as QuestionnaireFormatObjectDrawer } from "../QuestionnaireFormatObjectDrawer.vue";
import { IFormatPageLocatable, IFormatPageLocationResult } from "./IFormatPageLocatable";
import { QuestionnaireLocatableMixin } from "./mixins";
import { QuestionnaireFormatObject } from "../../../../../domain/questionnaire/constants";

@Component({
  components: {
    QuestionnaireFormatObjectDrawer,
  },
})
export default class QuestionnaireFormatPageLocator extends Mixins(QuestionnaireLocatableMixin, RectangleLayoutableMixin) implements IFormatPageLocatable {
  @Prop()
  zIndex: number;

  @Prop()
  objects: IFormatObjectEditable[];

  @Prop({ default: () => [] as QuestionnaireGuidTree<IFormatObjectEditable>[] })
  treeItems: QuestionnaireGuidTree<IFormatObjectEditable>[];

  data(): any {
    return {
      requestPool: new AsyncRequestPool<any, IFormatObjectEditable>(r => this.located(r.source)),
      source: null,
      offsets: new DraggingOffsets<IFormatObjectEditable>(null),
    };
  }
  requestPool: AsyncRequestPool<any, IFormatObjectEditable>;
  source: IFormatObjectEditable;
  offsets: DraggingOffsets<IFormatObjectEditable>;

  get gappedOffsets(): DraggingOffsets<IFormatObjectEditable> {
    return new DraggingOffsets<IFormatObjectEditable>(
      this.offsets.source,
      this.offsets.relocatingOffset.add(new Point(QuestionnaireFormatObject.Gap, 0)),
      this.offsets.transformingRatesFromCenter,
      this.offsets.transformingVector,
    );
  }

  get rootStyle(): any {
    return {
      zIndex: this.zIndex,
    };
  }

  get message(): string {
    if (this.isLocating) {
      return "オブジェクトを追加する位置でクリックしてください。";
    } else {
      return "";
    }
  }

  get isVisible(): boolean {
    return this.isLocating;
  }

  get isObjectVisible(): boolean {
    return this.requestPool.isProcessing
      && (this.isLocatorVisible);
  }

  toAppenderStyle(index: number) {
    return {
      height: `${(this.editingSource.index === index && !this.editingSource.isHit) ? this.toObjectHeight(this.source) + (QuestionnaireFormatObject.Gap * 2) : QuestionnaireFormatObject.Gap}px`,
    };
  }

  toObjectStyle(index: number, source: IFormatObjectEditable): any {
    return {
      "height": `${this.toObjectHeight(source)}px`,
      "background-color": (this.editingSource.index === index && this.editingSource.isHit) ? "#0000FF3F" : undefined,
    };
  }

  toObjectHeight(source: IFormatObjectEditable): number {
    return instanceOfIRectangleCoordinateEditable(source)
      ? source.size().getValue().height
      : 0;  // TODO: 矩形以外の対応が必要になったら実装.
  }

  get sourceHeight(): number {
    return this.source ? this.toObjectHeight(this.source) : 0;
  }

  @Watch("locatorRectangle")
  onLocatorRectangleUpdated(newValue: Rectangle, oldValue: Rectangle): void {
    this.onObjectRectangleUpdated(newValue, oldValue);
  }

  @Watch("layouterRectangle")
  onLayouterRectangleUpdated(newValue: Rectangle, oldValue: Rectangle): void {
    this.onObjectRectangleUpdated(newValue, oldValue);
  }

  private onObjectRectangleUpdated(newValue: Rectangle, oldValue: Rectangle): void {
    if (!this.isObjectVisible) {
      return;
    }
    if (instanceOfIRectangleCoordinateEditable(this.source)) {
      const size = this.source.size().getValue();
      this.offsets = new DraggingOffsets(
        this.source,
        newValue.topLeft,
        new Rectangle(
          new Point(1, 1),
          new Size(newValue.width / size.width, newValue.height / size.height)
        ),
        new Vector(new Point(0, 0), new Point(0, 0)),
      );
    }
  }

  @Emit()
  located(located: IFormatObjectEditable): void {}

  async locateObject(requester: any, source: IFormatObjectEditable): Promise<IFormatPageLocationResult<Point>> {
  // メソッドと挙動が合わないがI/F仕様なのでやむなし.
    return {
      result: (await this.layoutRectangleObject(requester, source)).result.topLeft
    };
  }

  async locateObjectVertically(requester: any, source: IFormatObjectEditable): Promise<IFormatPageLocationResult<Point>> {
    // メソッドと挙動が合わないがI/F仕様なのでやむなし.
    return {
      result: (await this.layoutRectangleObject(requester, source)).result.topLeft
    };
  }

  async selectRectangle(requester: any): Promise<Rectangle> {
    return this.request<Rectangle>(
      null,
      requester,
      () => this.layoutRectangle(0),
    );
  }

  async layoutRectangleObject(requester: any, source: IFormatObjectEditable, fixedAspectRatio: number = 0): Promise<IFormatPageLocationResult<Rectangle>> {
    // メソッドと挙動が合わないがI/F仕様なのでやむなし.
    if (!instanceOfIRectangleCoordinateEditable(source)) {
      throw new Error("矩形座標系ではありません.");
    }
    const size = source.size().getValue();
    return this.request<IFormatPageLocationResult<Rectangle>>(
      source,
      requester,
      () => this.locate(new Rectangle(new Point(0, 0), new Size(size.width, size.height))),
    );
  }

  async layoutLinearObject(requester: any, source: IFormatObjectEditable): Promise<IFormatPageLocationResult<Vector>> {
    // メソッドと挙動が合わないがI/F仕様なのでやむなし.線形オブジェクトはQuestionnaireでは存在しないはず.
    throw new Error("実装されてません.必要になるようなら実装してください.(今の所不要と判断.)");
  }

  async layoutPointsObject(requester: any, source: IFormatObjectEditable): Promise<IFormatPageLocationResult<Point[]>> {
    // メソッドと挙動が合わないがI/F仕様なのでやむなし.自由曲線オブジェクトはQuestionnaireでは存在しないはず.
    throw new Error("実装されてません.必要になるようなら実装してください.(今の所不要と判断.)");
  }

  private async request<T>(source: IFormatObjectEditable, requester: any, request: () => Promise<any>): Promise<T> {
    // 連続作成時に複数回呼び出されるため、正しい位置情報を取得出来るようキャンセルする
    if (this.source) {
      this.cancel(requester);
      await AsyncUtility.wait(() => !this.source);
    }
    this.source = source;
    const result = await this.requestPool.request(source, requester, request) as T;
    this.source = null;
    return result;
  }

  cancel(requester: any): void {
    if (this.requestPool.cancel(requester)) {
      // 実行中リクエストのキャンセル.
      this.cancelLocating();
    }
  }
}
